export const IS_MEMBER = 'isMember';
export const NOT_A_MEMBER = 'notAMember';
export const NO_MEMBER_STATUS = 'noMemberStatus';
